import PhoneDevice from './PhoneDevice';

const rows = [
  {
    title: 'لوحة تحكم ذكية',
    description: 'شوف اشتراكك، غسلاتك المتبقية، وأقرب المغاسل من شاشة واحدة.',
    src: '/app/index.html?demo=home&embed=1',
    reverse: false,
    showTabBar: true,
  },
  {
    title: 'رمز QR آمن ومتجدد',
    description: 'رمز يتجدد كل ٣٠ ثانية، مربوط بجهازك فقط. ما يمكن نسخه أو مشاركته.',
    src: '/app/index.html?demo=qr&embed=1',
    reverse: true,
    showTabBar: true,
  },
  {
    title: 'اختر سيارتك واشترك',
    description: 'اختر نوع سيارتك، ادفع عبر زين كاش، واستلم اشتراكك بلحظات.',
    src: '/app/index.html?demo=subscribe&embed=1',
    reverse: false,
    showTabBar: false,
  },
  {
    title: 'تابع دورك لحظة بلحظة',
    description: 'اترك سيارتك وتابع الطابور من أي مكان. نرسل لك إشعار لما تجهز.',
    src: '/app/index.html?demo=queue&embed=1',
    reverse: true,
    showTabBar: false,
  },
];

export default function AppShowcaseSection() {
  return (
    <section className="py-16 md:py-24 px-4 bg-surface">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-20 anim-fade-up">
          <h2 className="text-2xl md:text-3xl font-bold text-text-brand font-cairo mb-2">شوف التطبيق</h2>
          <p className="text-text-muted">تجربة سهلة من البداية للنهاية</p>
        </div>

        <div className="flex flex-col gap-16 md:gap-28">
          {rows.map((row, i) => (
            <div
              key={row.title}
              className={`flex flex-col ${row.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-16`}
            >
              {/* Phone */}
              <div className={row.reverse ? 'anim-slide-left' : 'anim-slide-right'}>
                <PhoneDevice src={row.src} showTabBar={row.showTabBar} />
              </div>

              {/* Text */}
              <div className={`flex-1 text-center md:text-right ${row.reverse ? 'anim-slide-right' : 'anim-slide-left'} delay-${(i % 4) + 1}`}>
                <h3 className="text-xl md:text-2xl font-bold text-text-brand font-cairo">{row.title}</h3>
                <p className="text-text-muted mt-3 leading-relaxed max-w-md mx-auto md:mx-0">{row.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
